import React from 'react';
import PropTypes from 'prop-types';
import { isBrowser } from '../../utils/is-browser.js';
import {
  Card,
  CardTitle,
  CardImage,
  ImageWrapper,
  LinkWrapper,
  CardLink,
} from './styles';

/**
 * Displays a title, thumbnail image, and description, linking through to a piece of content
 */
const ContentCard = ({
  title,
  image,
  description,
  link,
  currentCardCount,
  rowName,
}) => {
  if (!image) return null;

  const analyticsData = {
    event: 'cardClick',
    buttonCTA: title,
    buttonLocation: isBrowser ? window.location.pathname : null,
    cardPosition: currentCardCount + 1,
    cardRow: rowName,
    cardContext: title,
    cardTitle: description,
    cardSection: isBrowser ? window.location.pathname.split('/')[1] : null,
  };

  return (
    <Card>
      <ImageWrapper>
        <CardImage
          mobileW={600}
          mobileH={350}
          desktopW={600}
          desktopH={350}
          fit="fill"
          focusArea="center"
          image={image}
          presentational
        />
        {title && <CardTitle>{title}</CardTitle>}
      </ImageWrapper>
      <LinkWrapper>
        <CardLink
          link={link}
          className="tracking-card"
          dataTracking="card"
          analyticsData={analyticsData}
        >
          {description}
        </CardLink>
      </LinkWrapper>
    </Card>
  );
};

// TODO: the `color` prop has been deprecated for rebrand
// Post launch this can be removed from the content model
ContentCard.propTypes = {
  currentCardCount: PropTypes.number,
  description: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  link: PropTypes.object.isRequired,
  rowName: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default ContentCard;
